import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  beta: {
    id: 'frontbucket.components.lozenges.beta',
    description: 'Text for beta lozenge',
    defaultMessage: 'Beta',
  },
  new: {
    id: 'frontbucket.components.lozenges.new',
    description: 'Text for new lozenge',
    defaultMessage: 'New',
  },
  premium: {
    id: 'frontbucket.components.lozenges.premium',
    description: 'Text for premium lozenge',
    defaultMessage: 'Premium',
  },
});
